import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { UserDataStoreService } from "../services/user-data-store.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MerchantService } from "../services/merchant.service";
import { Router } from '@angular/router';
import { PermissionEnum, AccessPolicyEnum } from "../services/guards/permissions";
import { AuthenticationService } from "../services/authentication.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { DataTablesResponseViewModel } from '../models/data-tables-response-view-model';
import { environment } from '../../environments/environment';
import { MerchantReportDTViewModel } from '../models/merchant-report-dt-view-model';
import { ReportService } from '../services/report.service';
import { ToastrService } from 'ngx-toastr';
import { MerchantReportRegistrationComponent } from './merchant-report-registration/merchant-report-registration.component';
import { CreateResult } from '../models/create-result';

@Component({
  selector: 'app-report-management',
  templateUrl: './report-management.component.html',
  styleUrls: ['./report-management.component.scss']
})
export class ReportManagementComponent implements OnInit {

  public dtTrigger: Subject<boolean> = new Subject();
  public merchants: MerchantReportDTViewModel[] = [];
  public searchDebounce = new Subject<string>();


  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  public canManage = false;
  public descriptionSearch = '';
  public merchantIdSearch = '';
  public usnNumberSearch = '';
  public clientSearch = '';

  public editView: string;

  public createResult: CreateResult;
  constructor(
    private _httpClient: HttpClient,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _reportService: ReportService,
    private _ngxUiLoaderService: NgxUiLoaderService, private _toastService: ToastrService) {

    this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ManageTutukaManagementReportSetups]);
    if (!this.canManage) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }

    this.searchDebounce.pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(async value => {
        await this.refreshTable();
      });

  }


  ngOnInit() {

  }


  public async ngAfterViewInit(): Promise<void> {

    this.dtTrigger.next();
    //await this.init();

  }

  private resetDatatable(): void {

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });

  }

  private async refreshTable(): Promise<void> {
    await this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.setupFilters();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public setupFilters(): void {
    const searchColumns = this.columns.map((col) => {
      if (!!(col).search) {
        return { search: (col).search.value, regex: (col).search.regex };
      } else {
        return null;
      }
    });
    //this.dtOptions.searchCols = searchColumns;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      let i = 0;
      for (const item of searchColumns) {
        if (item) {
          dtInstance.column(i).search(item.search, item.regex);
        }
        i++;
      }
    })
  }

  public columns: any[] = [
    { data: 'usnNumber', title: 'USNNumber', visible: true, searchable: true, search: { value: this.usnNumberSearch, regex: true } },
    { data: 'merchantNumber', title: 'Merchant Number', visible: true, searchable: true, search: { value: this.merchantIdSearch, regex: true } },
    { data: 'participantId', title: 'Participant Id', visible: true, searchable: true, search: { value: this.descriptionSearch, regex: true } },
  ];

  private searchColumns = this.columns.map((col) => {
    if (!!col.search) {
      return { search: col.search.value, regex: col.search.regex };
    } else {
      return null;
    }
  });

  public dtOptions: DataTables.Settings = {
    pageLength: 10,
    serverSide: true,
    processing: true,
    ajax: (dataTablesParameters: any, callback) => {
      this._httpClient
        .post<DataTablesResponseViewModel>(
          `${environment.apiUrl}/api/report/Search`,
          dataTablesParameters, {}
        ).subscribe(resp => {
          this.merchants = resp.data;

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });
        });
    },
    columns: this.columns,
    searchCols: this.searchColumns

  };
  public get displayColumns() {
    return this.dtOptions.columns.filter(x => x.visible != false);
  }

  public async addMerchant(): Promise<void> {
    this._router.navigate(['management', 'report', 'new']);
  }

  public async editMerchant(merchant: MerchantReportDTViewModel): Promise<void> {
    this._router.navigate(['management', 'report', merchant.usnNumber]);
  }

  public async clientparticipantlink(): Promise<void> {
    this._router.navigate(['management', 'report-client-participant-link']);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  public async manageUsers(): Promise<void> {
    this._router.navigate(['management', 'report-user', 'new']);
  }

  public async registerMerchant(): Promise<void> {
    const modalRef = this._modalService.open(MerchantReportRegistrationComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    //await modalRef.result;

    // Close modal event listener
    await modalRef.result.then((result) => {
      // Call the function to execute DataTables code after modal is closed
      //this.redirect();
      this.refreshTable();
    });
  }

  public async SyncMerchants(): Promise<void> {
    this._ngxUiLoaderService.start();
    debugger;
    this.createResult = await this._reportService.SyncMerchants(this._userDataStore.selectedParticipant.id);
    if (this.createResult.success == true) {
      this._toastService.success(this.createResult.message, "Success");
      await this.refreshTable();
    }
    else {
      this._toastService.error(this.createResult.message, "Error");
    }
    this._ngxUiLoaderService.stop();
  }
}
